import { api } from './api';
import {
  ManualReviewTask,
  ManualReviewTaskListResponse,
  ManualReviewTaskDetailResponse,
  ResolveManualReviewRequest,
  RejectManualReviewRequest,
  KYCReviewTaskStatus,
} from '@mygate/common';
import { kycService } from './kyc';

export interface FetchReviewTasksFilters {
  status?: KYCReviewTaskStatus;
  page?: number;
  limit?: number;
}

class KycReviewTasksService {
  /**
   * Fetch manual-review task queue with optional filters
   */
  async fetchReviewTasks(filters?: FetchReviewTasksFilters) {
    const params = new URLSearchParams();

    if (filters?.status) params.append('status', filters.status);
    if (filters?.page) params.append('page', filters.page.toString());
    if (filters?.limit) params.append('limit', filters.limit.toString());

    const queryString = params.toString();
    const endpoint = `/api/staff/kyc-review-tasks${queryString ? `?${queryString}` : ''}`;

    const response = await api.get<ManualReviewTaskListResponse>(endpoint);
    return response.data;
  }

  /**
   * Get a single task by ID (includes kycCase summary)
   */
  async getReviewTask(id: string) {
    const response = await api.get<ManualReviewTaskDetailResponse>(`/api/staff/kyc-review-tasks/${id}`);
    return response.data;
  }

  /**
   * Resolve a task — staff keys in the missing document data
   */
  async resolveTask(id: string, body: ResolveManualReviewRequest) {
    const response = await api.post<ManualReviewTask>(`/api/staff/kyc-review-tasks/${id}/resolve`, body);
    return response.data;
  }

  /**
   * Reject a task — staff decides the document cannot be confirmed
   */
  async rejectTask(id: string, body: RejectManualReviewRequest) {
    const response = await api.post<ManualReviewTask>(`/api/staff/kyc-review-tasks/${id}/reject`, body);
    return response.data;
  }

  /**
   * Download the PostIdent result PDF for the underlying KYC case.
   * Reuses the same endpoint as kycService.downloadResultPdf.
   */
  downloadResultPdf(kycCaseId: string): Promise<Blob> {
    return kycService.downloadResultPdf(kycCaseId);
  }
}

export const kycReviewTasksService = new KycReviewTasksService();
